/**
 * English for the landers (card У7): the library, a lander's five tabs and
 * the new-lander sheet (boards LanderList … LanderEmpty). Spread into `en`, so
 * the keys are part of `TKey` and `ru.landers.ts` must cover each.
 */
export const enLanders = {
  "landers.title": "Landers",
  "landers.subtitle": "Pages a person sees before the offer and after the lead. Numbers are for the period above.",
  "landers.new": "New lander",
  "landers.layout": "List layout",
  "landers.layout.table": "Table",
  "landers.layout.tiles": "Tiles",
  "landers.loadFailed": "Could not load the landers",
  "landers.notFound": "Lander not found",
  "landers.back": "Back to landers",
  "landers.tabs": "Lander sections",
  "landers.tab.preview": "Preview",
  "landers.tab.numbers": "Numbers",
  "landers.tab.versions": "Versions",
  "landers.tab.settings": "Settings",
  "landers.tab.usage": "Where it is used",
  "landers.search": "Name, id, address",
  "landers.search.label": "Search landers",
  "landers.search.clear": "Clear search",
  "landers.count": "{n} {landers}",
  "landers.word.landers": "lander|landers",
  "landers.word.campaigns": "campaign|campaigns",
  "landers.word.campaignsIn": "campaign|campaigns",
  "landers.sortedBy": "sorted by {by}",
  "landers.sort.name": "name",
  "landers.sort.risk": "risk",
  "landers.sort.updated": "changed",
  "landers.inCampaigns": "in {n} {campaigns}",
  "landers.unused": "not used",
  "landers.noVersion": "no version",
  "landers.changed": "changed {at}",
  "landers.col.name": "Name",
  "landers.col.type": "Type",
  "landers.col.lang": "Lang",
  "landers.col.countries": "Countries",
  "landers.col.version": "Version",
  "landers.col.visits": "Visits",
  "landers.col.lpCtr": "LP CTR",
  "landers.col.leads": "Leads",
  "landers.col.campaigns": "Campaigns",
  "landers.col.risk": "Risk",
  "landers.col.updated": "Changed",
  "landers.page.prev": "Previous",
  "landers.page.next": "Next",
  "landers.page.summary": "{from}–{to} of {total}",
  "landers.page.of": "Page {page} of {pages}",
  "landers.page.perPage": "per page",
  "landers.filtered.title": "No landers match these filters",
  "landers.filtered.body": "Remove a filter or search differently.",
  "landers.filtered.reset": "Reset filters",
  "landers.facet.type": "Type",
  "landers.facet.lang": "Language",
  "landers.facet.country": "Country",
  "landers.facet.risk": "Risk",
  "landers.facet.used": "In use",
  "landers.facet.used.yes": "yes",
  "landers.facet.used.no": "no",
  "landers.filter.active": "List filters",
  "landers.filter.remove": "Remove the «{name}» filter",
  "landers.filter.edit": "Change the «{name}» filter",
  "landers.filter.any": "All",
  "landers.filter.add": "Filter",
  "landers.filter.facets": "Filter by",
  "landers.filter.search": "Find: {name}",
  "landers.filter.apply": "Apply",
  "landers.filter.reset": "Reset",
  "landers.filter.nothing": "Nothing found",
  "landers.filter.loading": "Loading…",
  "landers.filter.back": "Back",
  "landers.type.landing": "Landing",
  "landers.type.prelanding": "Prelanding",
  "landers.type.vsl": "VSL",
  "landers.type.white": "White page",
  "landers.type.whiteShort": "White",
  "landers.type.thanks": "Thank you",
  "landers.type.default": "default",
  "landers.risk.safe": "Safe",
  "landers.risk.warn": "Check",
  "landers.risk.danger": "Danger",
  "landers.kpi.landers": "Landers",
  "landers.kpi.inCampaigns": "{n} in campaigns",
  "landers.kpi.visits": "Visits",
  "landers.kpi.people": "people {n}",
  "landers.kpi.wentOn": "Went on",
  "landers.kpi.wentOn.note": "to the offer or the next step",
  "landers.kpi.lpCtr": "LP CTR",
  "landers.kpi.leads": "Conversions",
  "landers.kpi.cr": "CR {cr}",
  "landers.kpi.risky": "Flagged as risky",
  "landers.kpi.dangerLive": "{n} dangerous one live",
  "landers.kpi.dangerNone": "no dangerous one live",
  "landers.empty.title": "No landers yet",
  "landers.empty.body": "A lander is the page a person sees between the ad and the offer. Upload an archive, give the address of a ready page, or take one from the studio.",
  "landers.empty.studio": "Take from the studio",
  "landers.empty.kinds": "The kinds of page",
  "landers.empty.about.prelanding": "A story before the offer: an interview, a news piece, a review. Warms up and leads on.",
  "landers.empty.about.landing": "The offer's page with a lead form or a button to the partner.",
  "landers.empty.about.vsl": "A video sale: the person watches, then sees the button.",
  "landers.empty.about.white": "Moderators and bots see it instead of the real lander.",
  "landers.empty.about.thanks": "After the lead: the confirmation and the conversion pixel.",
  "landers.create.title": "New lander",
  "landers.create.description": "The page a person sees before the offer or after the lead. Links and macros are checked after the upload.",
  "landers.create.close": "Close",
  "landers.create.from": "Where the page comes from",
  "landers.create.zip": "Upload a ZIP",
  "landers.create.zip.body": "an archive with index.html, up to 50 MB",
  "landers.create.link": "By link",
  "landers.create.link.body": "the page already lives at its own address",
  "landers.create.studio": "From the studio",
  "landers.create.studio.body": "a finished lander from the landing studio",
  "landers.create.studio.how": "A studio lander is published to the tracker from the studio itself: open it there and press «Publish to tracker» — it appears here with its versions.",
  "landers.create.studio.open": "Open the studio",
  "landers.create.studio.foot": "The lander arrives from the studio by itself",
  "landers.create.drop": "Drop a ZIP here or choose a file",
  "landers.create.dropHere": "Drop the archive",
  "landers.create.dropRules": "up to 50 MB · index.html at the archive's root",
  "landers.create.zipOnly": "A .zip archive is needed",
  "landers.create.tooBig": "The archive is over 50 MB",
  "landers.create.needZip": "Choose an archive",
  "landers.create.removeZip": "Remove the archive",
  "landers.create.size": "{size} MB",
  "landers.create.progress": "{loaded} of {total} MB · {pct}%",
  "landers.create.url": "The page's address",
  "landers.create.url.hint": "The page is taken with its pictures and styles; what cannot be taken stays a link to the original site.",
  "landers.create.nameFromZip": "Taken from the archive's name — you can change it.",
  "landers.create.nameFromLink": "Taken from the address — you can change it.",
  "landers.create.namePlaceholder": "pl-joints-andrzej-kowalski",
  "landers.create.after": "After the upload we check: is there an index.html, how many buttons lead on, which macros it carries. The result is on «Preview».",
  "landers.create.zipFoot": "Created once the archive is uploaded",
  "landers.create.linkFoot": "Created once the page is taken",
  "landers.create.working": "Creating…",
  "landers.create.cancel": "Cancel",
  "landers.create.submit": "Create the lander",
  "landers.create.firstNote": "First upload",
  "landers.create.fromLink": "Taken by link",
  "landers.create.skipped": "{n} files could not be taken — they stay links to the original site",
  "landers.create.done": "Lander «{name}» created",
  "landers.create.failed": "Could not create the lander",
  "landers.create.pageFailed": "The lander was created but its page did not arrive: {error}. Upload it in «Versions».",
  "landers.f.name": "Name",
  "landers.f.type": "Type",
  "landers.f.language": "Language",
  "landers.f.language.none": "not set",
  "landers.f.countries": "Countries",
  "landers.f.countries.add": "Add a country…",
  "landers.f.risk": "Moderation risk",
  "landers.err.name": "A name is needed",
  "landers.err.nameLong": "At most 200 characters",
  "landers.err.url": "An address like https://… is needed",
  "landers.err.ctas": "From 1 to 20 buttons",
  "landers.head.version": "version",
  "landers.head.from": "from {at}",
  "landers.head.noVersion": "no page uploaded yet",
  "landers.head.author": "by {name}",
  "landers.head.open": "Open on the domain",
  "landers.head.noDomain": "The lander has no domain — opened inside the tracker",
  "landers.head.openFailed": "Could not open the lander",
  "landers.head.duplicate": "Duplicate",
  "landers.head.copyName": "{name} (copy)",
  "landers.head.testName": "{name} (test)",
  "landers.head.copied": "Copy «{name}» created",
  "landers.head.copyFailed": "Could not make a copy",
  "landers.head.more": "More",
  "landers.head.download": "Download the current version",
  "landers.head.archive": "Archive",
  "landers.archive.title": "Archive «{name}»?",
  "landers.archive.body": "The lander leaves the list; its numbers stay in the reports.",
  "landers.archive.live": "{n} {campaigns} show it — archiving does not take it out of their rotation, remove it in the campaign editor.",
  "landers.archive.confirm": "Archive",
  "landers.archive.done": "«{name}» archived",
  "landers.archive.failed": "Could not archive",
  "landers.n.visits": "Visits",
  "landers.n.bots": "bots {pct} filtered",
  "landers.n.people": "People",
  "landers.n.leads": "Leads",
  "landers.n.approved": "Approved",
  "landers.n.approve": "approve {pct}",
  "landers.n.epc": "Revenue per visit",
  "landers.n.chart.day": "People, went on and leads by day",
  "landers.n.chart.hour": "People, went on and leads by hour",
  "landers.n.leadsAxis": "leads, right scale",
  "landers.n.grain": "Chart step",
  "landers.n.grain.day": "Day",
  "landers.n.grain.hour": "Hour",
  "landers.n.noTraffic": "No traffic through the lander in the period",
  "landers.n.running": "running",
  "landers.n.byCampaign": "By campaign",
  "landers.n.shareNote": "the lander's share of the campaign's rotation",
  "landers.n.byCountry": "By country",
  "landers.n.openReport": "Open in the report",
  "landers.n.col.campaign": "Campaign",
  "landers.n.col.share": "Share",
  "landers.n.col.cr": "CR",
  "landers.n.col.revenue": "Revenue",
  "landers.n.col.country": "Country",
  "landers.n.noCountry": "country unknown",
  "landers.n.total": "Total",
  "landers.v.title": "Versions",
  "landers.v.compareHint": "the compared ones are highlighted",
  "landers.v.drop": "Drop the ZIP of a new version",
  "landers.v.dropRules": "up to 50 MB · index.html at the archive's root · becomes v{v}, does not become current by itself",
  "landers.v.dropFirst": "up to 50 MB · index.html at the archive's root · becomes v{v} and is shown at once",
  "landers.v.choose": "Choose a file",
  "landers.v.none": "No versions yet — upload a ZIP.",
  "landers.v.noNote": "no description",
  "landers.v.noteSave": "Save the description",
  "landers.v.noteFailed": "Could not save the description",
  "landers.v.files": "{n} files",
  "landers.v.failed": "failed to build",
  "landers.v.served": "Shown",
  "landers.v.promote": "Make current",
  "landers.v.promoted": "v{v} is now shown",
  "landers.v.promoteFailed": "Could not make it current",
  "landers.v.download": "Download v{v}",
  "landers.v.downloadFailed": "Could not download",
  "landers.v.uploaded": "v{v} uploaded",
  "landers.v.uploadFailed": "Could not upload the archive",
  "landers.v.compare": "Comparison",
  "landers.v.compareFrom": "The version to compare",
  "landers.v.compareTo": "Against the version",
  "landers.v.currentLabel": "v{v} · current",
  "landers.v.filesChanged": "{n} files",
  "landers.v.mode": "How to show the changes",
  "landers.v.mode.inline": "Line by line",
  "landers.v.mode.side": "Side by side",
  "landers.v.compareNone": "Two versions are needed to compare.",
  "landers.v.diffFailed": "Could not compare the versions",
  "landers.v.same": "The versions are the same.",
  "landers.v.change.added": "new",
  "landers.v.change.removed": "removed",
  "landers.v.change.modified": "changed",
  "landers.v.change.replaced": "replaced",
  "landers.v.lines": "lines {ranges}",
  "landers.v.binary": "Not a text file — compared as a picture below.",
  "landers.v.tooLarge": "The file is too large to compare line by line.",
  "landers.v.pictures": "Pictures are compared side by side: {path} v{from} · v{to}",
  "landers.s.main": "Main",
  "landers.s.main.hint": "Only the tracker shows the name.",
  "landers.s.type": "Page type",
  "landers.s.type.hint": "The type decides where it can stand in a campaign's flow.",
  "landers.s.risk.safe": "can be shown to everyone",
  "landers.s.risk.warn": "has arguable claims or before/after photos",
  "landers.s.risk.danger": "people only; bots and moderators get the white page",
  "landers.s.audience": "Audience",
  "landers.s.audience.hint": "A hint for the campaign editor: which countries and language.",
  "landers.s.language": "Page language",
  "landers.s.after": "After the lead",
  "landers.s.after.hint": "Which «Thank you» page the person sees.",
  "landers.s.after.thanks": "This page is a «Thank you» itself.",
  "landers.s.after.where": "The «Thank you» is chosen in the campaign; when it is not — the lander's own thankyou.html, else the default «Thank you» for {lang}.",
  "landers.s.default": "Default for its language",
  "landers.s.default.hint": "Shown after the lead in every campaign without its own «Thank you» whose lander is in {lang}.",
  "landers.s.tracking": "Tracking",
  "landers.s.tracking.hint": "How the tracker sees the page's buttons.",
  "landers.s.ctas": "Buttons on the page",
  "landers.s.domain": "Domain",
  "landers.s.clickUrl": "The buttons' link",
  "landers.s.clickUrl.hint": "Put it in each button's href; in the archive — the {click_url} macro.",
  "landers.s.script": "Tracker script",
  "landers.s.script.hint": "For a page outside the tracker; an uploaded archive does not need it.",
  "landers.s.copy": "Copy: {what}",
  "landers.s.copied": "Copied",
  "landers.s.copyFailed": "Could not copy",
  "landers.s.notes": "Notes and tags",
  "landers.s.notes.hint": "For yourself: where it came from, what is tested.",
  "landers.s.notes.ph": "Taken from the partner DrCash on 07.10, translated…",
  "landers.s.tags": "Tags",
  "landers.s.tags.add": "Tag…",
  "landers.s.tags.none": "no tags",
  "landers.s.changed": "Changed: {what}",
  "landers.s.changed.name": "name",
  "landers.s.changed.type": "type",
  "landers.s.changed.risk": "risk",
  "landers.s.changed.countries": "countries",
  "landers.s.changed.language": "language",
  "landers.s.changed.tracking": "tracking",
  "landers.s.changed.notes": "notes",
  "landers.s.changed.tags": "tags",
  "landers.s.seenBy": "every one of the {n} {campaigns} sees it at once",
  "landers.s.save": "Save",
  "landers.s.discard": "Discard",
  "landers.s.saved": "Settings saved",
  "landers.s.saveFailed": "Could not save",
  "landers.u.alert": "Every one of the {n} {campaigns} sees a new version at once",
  "landers.u.alert.body": "To try a change on part of the traffic, duplicate the lander and put the copy beside it in one campaign's rotation.",
  "landers.u.duplicate": "Duplicate for a test",
  "landers.u.campaigns": "Campaigns",
  "landers.u.campaigns.note": "numbers — only the traffic through this lander, for the period",
  "landers.u.none": "No live campaign shows it.",
  "landers.u.none.numbers": "Numbers for the period →",
  "landers.u.col.status": "Status",
  "landers.u.col.offer": "Offer",
  "landers.u.col.place": "Place in the flow",
  "landers.u.col.share": "Lander's share",
  "landers.u.col.profit": "Profit",
  "landers.u.place.only": "the only one",
  "landers.u.place.share": "by shares",
  "landers.u.place.graph": "hand-built flow",
  "landers.u.offers": "Offers it works with",
  "landers.u.offers.none": "Offers show for editor-made campaigns; hand-built flows have none here.",
  "landers.u.flow": "How it stands in the flow",
  "landers.u.flow.only": "the main lander, 100 %",
  "landers.u.flow.share": "rotation: a share of {pct} of {n} landers",
  "landers.u.flow.graph": "hand-built flow — the share follows the flow's graph",
  "landers.u.history": "History",
  "landers.u.h.version": "v{v} uploaded",
  "landers.u.h.current": "v{v} uploaded — shown",
  "landers.u.h.none": "No history yet",
  "landers.u.h.today": "Today",
  "landers.u.h.yesterday": "Yesterday",
  "landers.u.h.more": "Show more",
  "landers.p.device": "Device",
  "landers.p.phone": "Phone",
  "landers.p.tablet": "Tablet",
  "landers.p.desktop": "Computer",
  "landers.p.address": "The page's address",
  "landers.p.reload": "Reload",
  "landers.p.frame": "Lander preview",
  "landers.p.checks": "Check",
  "landers.p.check.page": "The page is uploaded — v{v}",
  "landers.p.check.page.body": "{files} files · arrived {at}",
  "landers.p.check.noPage": "No page uploaded yet",
  "landers.p.check.noPage.body": "Upload a ZIP — without a page the lander drops out of a campaign's rotation.",
  "landers.p.check.upload": "Upload",
  "landers.p.check.domain": "Served on {fqdn}",
  "landers.p.check.domain.bound": "the domain is bound to the tracker",
  "landers.p.check.domain.pending": "the domain is still being bound",
  "landers.p.check.domain.failed": "the domain failed to bind — see «Domains»",
  "landers.p.check.noDomain": "No domain chosen",
  "landers.p.check.noDomain.body": "The lander is served on the campaign's domain; its own one is in «Settings».",
  "landers.p.check.ctas": "Buttons leading on: {n}",
  "landers.p.check.ctas.body": "the page carries {click_url} — the click-throughs are counted",
  "landers.p.check.noClickUrl": "The page has no {click_url}",
  "landers.p.check.noClickUrl.body": "The buttons do not go through the tracker — «Went on» and LP CTR stay empty.",
  "landers.p.check.inline": "The offer is on the page",
  "landers.p.check.inline.body": "a lead form without leaving — «Went on» is not counted for such a lander",
  "landers.p.macros": "Macros on the page · {n}",
  "landers.p.macros.none": "The page has no macros.",
  "landers.p.macro": "Macro",
  "landers.p.sample": "Sample value",
  "landers.p.from": "From",
  "landers.p.from.page": "the page's own macro",
  "landers.p.test": "Trial substitution",
  "landers.p.test.run": "Check",
  "landers.p.test.again": "Again",
  "landers.p.test.hint": "Fills the sample values and shows the address on the domain — no click, nothing counted.",
  "landers.p.test.macros": "Macros filled: {n}",
  "landers.p.test.served": "The page is served",
  "landers.p.test.noEdge": "The lander has no domain — the address is inside the tracker only",
  "landers.p.fireFailed": "Could not check the substitution",
  "landers.f.language.pick": "Choose a language",
  "landers.s.notes.field": "Notes",
};
